import { Model } from "pinia-orm";
import QuestionnaireDocument from "@/models/QuestionnaireDocument";
import Question from "@/models/Question";

export default class QuestionQuestionnaireDocument extends Model {
  static entity = "questionQuestionnaireDocuments";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      questionnaireDocumentUuid: this.string(""),
      questionUuid: this.string(""),
      questionnaireDocumentData: this.belongsTo(
        QuestionnaireDocument,
        "questionnaireDocumentUuid",
        "documentUuid",
      ),
      questionData: this.belongsTo(Question, "questionUuid"),
    };
  }
}
